import React, { useState, useEffect, lazy, Suspense, useContext } from "react";
import { connect } from "react-redux";
import IntlMessages from "../../utils/IntlMessages";
import ServerMasterTable from "../../components/common/ServerMasterTable";
import { getTotalStock } from "../../redux/admin/Report/action";
import { LayoutContext } from "../../layouts/UserLayout";

const TotalStockReport = ({ getTotalStock, stockData,menuId }) => {
    const { setPageTitle } = useContext(LayoutContext);
  
  const [manageDetailsParam, setManageDetailsParam] = useState({
    limit: 50,
    offset: 0,
    searchTerm: "",
    orderBy: "createddate",
    format: "DESC",
  });
  const [report, setReport] = useState([]);

              useEffect(() => {
      setPageTitle(<IntlMessages id={menuId} />);
      
      return () => setPageTitle(""); 
    }, [setPageTitle]);

  useEffect(() => {
    getTotalStock(manageDetailsParam);
  }, [manageDetailsParam]);

  useEffect(() => {
    setReport(stockData?.length ? stockData : []);
  }, [stockData]);

  const cols = React.useMemo(
    () => [
      {
        Header: "S No.",
        accessor: "lo",
        cellClass: "text-center",
        Cell: (props) => (
          <>
            {parseInt(props?.row?.id) + 1 + parseInt(manageDetailsParam.offset)}
          </>
        ),
        sortType: "basic",
      },
      {
        Header: <IntlMessages id="plan-name" />,
        accessor: "planname",
        Cell: (props) => <>{props?.value ? props.value : " - "}</>,
        cellClass: "text-center",
        sortType: "basic",
      },
      {
        Header: <IntlMessages id="totalstock" />,
        accessor: "totalstock",
        Cell: (props) => <>{props?.value ? props.value : " - "}</>,
        cellClass: "text-center",
        sortType: "basic",
      },
      {
        Header: <IntlMessages id="activestock" />,
        accessor: "activestock",
        Cell: (props) => <>{props?.value ? props.value : " - "}</>,
        cellClass: "text-center",
        sortType: "basic",
      },
      {
        Header: <IntlMessages id="remainingstock" />,
        accessor: "remainingstock",
        Cell: (props) => <>{props?.value ? props.value : " - "}</>,
        cellClass: "text-center",
        sortType: "basic",
      }
    ],
    [manageDetailsParam]
  );

  return (
    <div className="p-3">

      <div className="card shadow-sm mt-3">
        <div className="card-body">
          <ServerMasterTable
            columns={cols}
            batchParam={manageDetailsParam}
            setBatchParam={setManageDetailsParam}
            data={report?.length ? report : []}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  stockData: state.report.stockData,
});

export default connect(mapStateToProps, {
  getTotalStock,
})(TotalStockReport);
